export default "__VITE_ASSET__Bwi58LRd__"